(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-wellhome-main"] && !Shopify.designMode) return;
  try {
    
  // Indice de la ficha de articulo.
  //
  // Se construye desde el cliente y NO desde Liquid porque el cuerpo del articulo llega
  // como una cadena de HTML: sacar sus `h2` en Liquid obligaria a partirla por `split`, que
  // se rompe en cuanto un titular lleve un atributo, una comilla o una etiqueta dentro.
  // Aqui el DOM ya esta construido y los `h2` son objetos, no texto.
  //
  // Es una mejora progresiva de verdad: si esto no llega a ejecutarse, el `<nav>` se queda
  // con su `hidden` puesto y la columna de lectura se centra sola. No hay estado roto.
  (() => {
    const MINIMO = 3; // con uno o dos apartados un indice estorba mas de lo que ayuda

    // Cada tabla se envuelve en una caja que se desplaza sola.
    //
    // POR QUE HACE FALTA, y se vio en un movil de 430: con `overflow-x: auto` puesto en la
    // PROPIA tabla, la tabla sigue encogiendo hasta el ancho disponible en vez de
    // desplazarse, y la primera columna acababa partida letra a letra ("Lu / z / qu / e /
    // dej / a"). El que se desplaza tiene que ser un contenedor DISTINTO del que lleva el
    // ancho minimo, y el HTML del articulo no trae ese contenedor: se pone aqui.
    //
    // El envoltorio es enfocable y se anuncia como region para que tambien se pueda
    // recorrer con el teclado, no solo arrastrando con el dedo.
    const envuelveTablas = (seccion) => {
      seccion.querySelectorAll('.aw__cuerpo > table').forEach((tabla) => {
        const caja = document.createElement('div');
        caja.className = 'aw__tabla';
        caja.tabIndex = 0;
        caja.setAttribute('role', 'region');
        caja.setAttribute('aria-label', tabla.caption ? tabla.caption.textContent.trim() : 'Tabla');
        tabla.parentNode.insertBefore(caja, tabla);
        caja.appendChild(tabla);
      });
    };

    const arranca = () => {
      document.querySelectorAll('.aw').forEach(envuelveTablas);

      document.querySelectorAll('.aw[data-indice="true"]').forEach((seccion) => {
        const nav = seccion.querySelector('.aw__indice');
        const lista = nav && nav.querySelector('.aw__indice-lista');
        const titulares = [...seccion.querySelectorAll('.aw__cuerpo > h2')];
        if (!lista || titulares.length < MINIMO) return;

        titulares.forEach((h2, i) => {
          // Se respeta el id que ya traiga el titular; si no trae, se le pone uno estable.
          if (!h2.id) h2.id = `apartado-${i + 1}`;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${h2.id}`;
          a.textContent = h2.textContent.trim();
          li.appendChild(a);
          lista.appendChild(li);
        });

        nav.hidden = false;
        seccion.classList.add('aw--con-indice');

        // Marca el apartado en el que esta el lector.
        //
        // NO con IntersectionObserver, y se probo: con una franja estrecha no habia
        // ningun titular dentro la mayor parte del recorrido y no se marcaba nada; con una
        // ancha se marcaban dos a la vez. El observador contesta «cuales se ven», que no
        // es la pregunta. La pregunta es «cual es el ultimo que he pasado», y eso es una
        // comparacion contra una linea fija bajo la cabecera. Asi SIEMPRE hay uno y solo
        // uno marcado, en cualquier posicion de la pagina.
        const enlaces = new Map(
          [...lista.querySelectorAll('a')].map((a) => [a.getAttribute('href').slice(1), a])
        );
        const LINEA = 150;
        let pedido = false;

        const marca = () => {
          pedido = false;
          let actual = titulares[0];
          titulares.forEach((h2) => {
            if (h2.getBoundingClientRect().top <= LINEA) actual = h2;
          });
          enlaces.forEach((a, id) => a.classList.toggle('is-actual', id === actual.id));
        };

        // El calculo se aplaza al siguiente fotograma: `scroll` se dispara decenas de veces
        // por segundo y `getBoundingClientRect` obliga al navegador a recalcular estilos.
        const alDesplazar = () => {
          if (pedido) return;
          pedido = true;
          requestAnimationFrame(marca);
        };

        marca();
        addEventListener('scroll', alDesplazar, { passive: true });
        addEventListener('resize', alDesplazar, { passive: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arranca, { once: true });
    } else {
      arranca();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-wellhome-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-wellhome')) {
    customElements.define('collection-wellhome', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-filter-form]');
        this.panel = this.querySelector('[data-filters-panel]');

        // Un solo listener para todo el formulario. El orden ya no tiene su propio
        // control fuera del panel: los radios `sort_by` llevan `data-auto` como los
        // checkboxes y entran por aqui. Se deja tambien la comprobacion por `name`
        // por si en algun momento vuelve a haber un control de orden sin `data-auto`.
        this.form?.addEventListener('change', (e) => {
          if (e.target.matches('[data-auto]') || e.target.name === 'sort_by') this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
        });

        this.scrim = document.createElement('div');
        this.scrim.className = 'cw-scrim';
        this.appendChild(this.scrim);
        this.querySelector('[data-filters-open]')?.addEventListener('click', (e) => { this.openFilters(e.currentTarget); });
        this.querySelector('[data-filters-close]')?.addEventListener('click', () => this.closeFilters());
        this.scrim.addEventListener('click', () => this.closeFilters());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.panel?.classList.contains('is-open')) {
            e.preventDefault();
            this.closeFilters();
          }
        });

        /* Las flechas del carrusel de hijas YA NO SE MANEJAN AQUI. Las lleva el modulo
           generico `assets/wellhome-carousel.js`, el mismo de "Top ventas", los
           relacionados y las opiniones, que ademas mueve la barra y oculta los dos
           controles cuando no hay desborde. Tener un carrusel propio aqui era una
           copia, y dos copias del mismo componente se separan solas con el tiempo. */
      }
      openFilters(trigger) {
        this.trigger = trigger;
        this.panel?.classList.add('is-open');
        this.scrim.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => this.querySelector('[data-filters-close]')?.focus());
      }
      closeFilters() {
        this.panel?.classList.remove('is-open');
        this.scrim.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        this.trigger?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-wellhome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-wellhome')) {
    customElements.define('faq-wellhome', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.singleOpen !== 'true') return;

        this.addEventListener('toggle', (event) => {
          const current = event.target;
          if (!(current instanceof HTMLDetailsElement) || !current.open) return;

          this.querySelectorAll('details[open]').forEach((item) => {
            if (item !== current) item.open = false;
          });
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-wellhome-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wellhome-product')) {
    customElements.define('wellhome-product', class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.querySelector('[data-gallery]');
        this.items = Array.from(this.querySelectorAll('[data-gallery-item]'));
        this.count = this.querySelector('[data-gallery-count]');
        this.progress = this.querySelector('[data-gallery-progress]');
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.moveGallery(-1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.moveGallery(1));
        this.gallery?.addEventListener('scroll', () => this.updateGallery(), { passive: true });
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
        this.updateGallery();
      }
      moveGallery(direction) {
        if (!this.gallery) return;
        this.gallery.scrollBy({ left: this.gallery.clientWidth * direction, behavior: 'smooth' });
      }
      updateGallery() {
        if (!this.gallery || !this.items.length) return;
        const index = Math.min(this.items.length - 1, Math.max(0, Math.round(this.gallery.scrollLeft / Math.max(1, this.gallery.clientWidth))));
        if (this.count) this.count.textContent = `${index + 1}/${this.items.length}`;
        if (this.progress) this.progress.style.setProperty('--whp-gallery-progress', String((index + 1) / this.items.length));
      }
      // El cambio de variante (precio, comparado, SKU, boton, imagen y URL)
      // lo gestiona assets/wellhome-product-quality.js, que se engancha a los
      // data-* de esta seccion. No duplicar esa logica aqui.
      changeQuantity(change) {
        const input = this.querySelector('[data-quantity] input');
        if (!input) return;
        input.value = Math.max(1, Number(input.value || 1) + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
